import { Validator } from '@fhnw/types/validator';
import { URLUtils } from '@plone/volto/helpers/Url/Url';
import { messages } from '@plone/volto/helpers/MessageLabels/MessageLabels';

export const customUrlValidator = ({ value, formatMessage }: Validator) => {
  const isValid = URLUtils.checkAndNormalizeUrl(value);
  return !isValid ? formatMessage(messages.isValidURL) : null;
};
